module.exports = __webpack_public_path__ + "static/media/MSLearn_SA_badge_generic_rgb_300ppi.7cc09d18.png";